(() => {
  if (customElements.get('mb-model-measurement')) return;

  class MartenbrownModelMeasurement extends HTMLElement {
    connectedCallback() {
      if (!this.mbBound) {
        const fields = Array.from(this.querySelectorAll('[data-model-field]'));
        const editor = this.querySelector('[data-model-editor]');
        const fallback = this.querySelector('[data-model-fallback]');
        const printWrapper = this.querySelector('[data-model-print-wrapper]');
        const reset = this.querySelector('[data-model-reset]');
        const status = this.querySelector('[data-model-status]');
        if (fields.length !== 9 || !editor || !fallback || !printWrapper || !reset || !status) return;

        const pairs = fields.map((field) => [field, this.querySelector(`[data-model-print="${field.dataset.modelField}"]`)]);
        if (pairs.some(([, print]) => !print)) return;
        this.mbRefresh = () => {
          for (const [field, print] of pairs) print.textContent = field.value;
        };
        for (const [field] of pairs) field.addEventListener('input', () => {
          status.textContent = '';
          this.mbRefresh();
        });
        reset.addEventListener('click', () => {
          for (const [field] of pairs) field.value = '';
          this.mbRefresh();
          status.textContent = this.dataset.cleared;
          fields[0].focus();
        });
        this.mbRefresh();
        this.mbBound = true;
        printWrapper.hidden = false;
        fallback.hidden = true;
        editor.hidden = false;
      }
      window.addEventListener('beforeprint', this.mbRefresh);
    }

    disconnectedCallback() {
      if (this.mbRefresh) window.removeEventListener('beforeprint', this.mbRefresh);
    }
  }

  customElements.define('mb-model-measurement', MartenbrownModelMeasurement);
})();
